import React from "react";
import PatientCaseListRow from "./PatientCaseListRow";

const PatientCaseList = (props) => {
  const { patientCases, addTab } = props;
  console.log(addTab);
  return (
    <div className="flex flex-col gap-[1.375rem] pt-[2.375rem] h-full max-h-[80%] overflow-auto box-border ">
      {Array.isArray(patientCases) && patientCases?.length > 0 ? (
        patientCases.map((caseData) => (
          <PatientCaseListRow
            exam={caseData}
            key={caseData.examId ?? "not-unique"}
            openTabOnClick = {(patientID,examId,dicomProps) =>addTab('case', patientID, examId, dicomProps)}
          />
        ))
      ) : (
        <p className='text-white'>No cases found.</p>
      )}
    </div>
  );
};

export default PatientCaseList;
